import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { StyledLink } from "orcs-design-system";
import { useGlobalConfig } from "src/contexts/global/GlobalContext";

/* Styled Components */
const AppHomeLink = styled(StyledLink)`
  display: none !important;

  &:hover {
    text-decoration: none;
  }

  @media screen and (min-width: ${(props) =>
      themeGet("breakpoints.3")(props)}) {
    display: inline-block !important;
  }
`;

const AppName = ({ defaultRoutePath }) => {
  const globalConfig = useGlobalConfig();

  const appName = globalConfig?.config?.appName;
  const linkAriaLabel = `Go to home page`;

  return (
    <AppHomeLink aria-label={linkAriaLabel} to={defaultRoutePath}>
      {appName}
    </AppHomeLink>
  );
};
AppName.propTypes = {
  defaultRoutePath: PropTypes.string,
};

export default AppName;
